export const mixin = {
  methods: {
    async getViewTime (to, next) {
      let recordPageData = localStorage.getItem('recordPageData') ? JSON.parse(localStorage.getItem('recordPageData')) : null
      let startTime = recordPageData.startTime // 本地访问页面的开始时间（时间戳）
      let endTime = new Date().getTime() // 本地访问页面的结束时间（时间戳）
      let viewTime = (endTime - startTime) // 页面的访问时长（时间戳）
      let online_time = viewTime / 1000
      let id = to.meta.id
      switch (to.meta.id) {
        case 11751:
        case 11786:
          id = 1132
          break
        case 11785:
          id = 11784
      }
      let { data } = await this.axios.post('/home/log/visitPage/add', { 'page_id': id, 'online_time': online_time })
      const { results, success } = data
      if (success === true) {
        localStorage.removeItem('recordPageData')
        console.log(results.msg)
      } else {
        localStorage.setItem('recordPageData', JSON.stringify({
          viewTime // 页面的访问时长（时间戳）
        }))
      }
      next()
    }
  },
  beforeRouteLeave (to, from, next) {
    this.getViewTime(from, next)
  }
}
